<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="img" aria-hidden="true">
    <path
      fill="currentColor"
      d="M12 0c.4 0 .7.1.9.4l9.3 9.3c.2.3.4.6.4.9 0 .3-.1.7-.4.9-.2.3-.5.5-.9.5-.3 0-.7-.1-.9-.4l-7.1-7.1v18.1c0 .4-.1.7-.4.9-.2.4-.5.5-.9.5s-.7-.1-.9-.4c-.2-.2-.4-.6-.4-.9V4.6l-7.1 7.1c-.2.2-.6.3-.9.3-.3 0-.7-.1-.9-.4-.2-.2-.4-.6-.4-.9 0-.3.1-.7.4-.9L11.1.5c.2-.4.5-.5.9-.5z"
    />
  </svg>
</template>
